import { Injectable } from '@angular/core';
import { Feature } from './feature';

@Injectable({
  providedIn: 'root'
})
export class FeatureStorageService {

  private features: Feature[] = [];

  loaded = false;

  constructor() { }

  loadFeatures() {
    return this.features;
  }

  storeFeature(feature) {
    this.features.push(feature);
  }

  clear() {
    this.features = [];
  }
}
